document.addEventListener('alpine:init', () => {
  window.scrollToSection = function (selector) {
    const element = document.querySelector(selector);

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  Alpine.data('autoTabs', (totalTabs) => ({
    activeTab: 0,
    totalTabs: totalTabs,
    interval: null,

    startAutoPlay() {
      this.stopAutoPlay();

      this.interval = setInterval(() => {
        this.activeTab = (this.activeTab + 1) % this.totalTabs;
      }, 5000);
    },

    stopAutoPlay() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },

    selectTab(index) {
      this.activeTab = index;
      this.stopAutoPlay();
    },

    init() {
      this.startAutoPlay();

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // Section visible
            if (entry.isIntersecting) {
              if (!this.interval) {
                this.startAutoPlay();
              }
            }
            // User left the section
            else {
              this.activeTab = 0; // start from first tab
              this.startAutoPlay();
            }
          });
        },
        {
          threshold: 0.2,
        }
      );

      observer.observe(this.$el);
    },
  }));
});